var UserFile = /** @class */ (function () {
    function UserFile() {
        this.id = 0;
        this.key = '';
        this.file_name = '';
        this.url = '';
        this.path = '';
        this.name = '';
        this.status = 'create';
        this.file_type = 'image';
        this.created_at = '';
    }
    return UserFile;
}());
export { UserFile };
